import { CheckboxOption, FilterType } from "./filter.interface";


export enum InputTypes {
  TEXT = "text",
  DROPDOWN = "dropdown",
  DROPDOWNWithIds = "dropdownIds",
  CHECKBOX = "checkbox",
  DATE = "date",
  RANGE_DATE = "rangeDate",
  MULTI_SELECT = "multiselect",
  RADIO = "radio",
}

export type Fields = `${InputTypes}`;

export const DummyFormConfig: Array<FilterType> = [
  {
    inputType: InputTypes.TEXT,
    controlName: "carrierName",
    title: "Company Name",
  },
  { inputType: InputTypes.TEXT, controlName: "first_Name", title: "Name" },
  { inputType: InputTypes.TEXT, controlName: "surname", title: "Surname" },
  {
    inputType: InputTypes.TEXT,
    controlName: "companyRegNumber",
    title: "Company Registration Number",
  },
  { inputType: InputTypes.TEXT, controlName: "id_number", title: "ID Number" },
  // {
  //     inputType: InputTypes.CHECKBOX,
  //     controlName: 'statusMultiSelect',
  //     title: 'Filter by one or more statuses...',
  //     checkboxOptions: []
  // },
];
export const ConsultantFormConfig: Array<FilterType> = [
  {
    inputType: InputTypes.TEXT,
    controlName: "consultantUserName",
    title: "User Name",
  },
  {
    inputType: InputTypes.CHECKBOX,
    controlName: "consultantStatusMultiSelect",
    title: "Status",
  },
  {
    inputType: InputTypes.CHECKBOX,
    controlName: "consultantRoleMultiSelect",
    title: "Role",
  },
];

export const ExternalRouteListFormConfig: Array<FilterType> = [
  {
    inputType: InputTypes.TEXT,
    controlName: "routeName",
    title: "Route Name",
  },
  {
    inputType: InputTypes.DROPDOWNWithIds,
    controlName: "provinceName",
    title: "Province of departure",
  },
  {
    inputType: InputTypes.DROPDOWNWithIds,
    controlName: "destinationCountry",
    title: "Destination country",
  },
  {
    inputType: InputTypes.RADIO,
    controlName: "routesDedicatedtoMyTransAssoc",
    title: "Show routes dedicated to my transport association ",
    radioOptions: { true: "Yes", no: "No" },
  },
  // {
  //     inputType: InputTypes.RADIO,
  //     controlName: 'cargoType',
  //     title: 'Cargo type',
  //     radioOptions: { Freight: 'Freight', Passenger: 'Passenger' }
  // },
];
export const InternalRouteListFormConfig: Array<FilterType> = [
  {
    inputType: InputTypes.TEXT,
    controlName: "routeName",
    title: "Route Name",
  },
  {
    inputType: InputTypes.DROPDOWNWithIds,
    controlName: "provinceName",
    title: "Province of departure",
  },
  {
    inputType: InputTypes.DROPDOWNWithIds,
    controlName: "destinationCountry",
    title: "Destination country",
  },
  {
    inputType: InputTypes.RADIO,
    controlName: "passenger_freight_id",
    title: "Permit Type",
    radioOptions: { 1: "Freight", 2: "Passenger" },
  },
];
export const EnquireConfig: Array<FilterType> = [
  {
    inputType: InputTypes.TEXT,
    controlName: "Carrier",
    title: "Carrier",
  },
  {
    inputType: InputTypes.DATE,
    controlName: "dateFrom",
    title: "Expiry Date From",
  },
  {
    inputType: InputTypes.DATE,
    controlName: "dateTo",
    title: "Expiry Date To",
  },
  {
    inputType: InputTypes.DROPDOWNWithIds,
    controlName: "permit_type",
    title: "Permit Type",
  },
  {
    inputType: InputTypes.TEXT,
    controlName: "permit_num",
    title: "Permit Number",
  },
  {
    inputType: InputTypes.TEXT,
    controlName: "vehicle_num",
    title: "Vehicle Number",
  },
  {
    inputType: InputTypes.CHECKBOX,
    controlName: "selectedItems",
    title: "Statuses",
    checkboxOptions: [],
  },
  // {
  //   inputType: InputTypes.CHECKBOX,
  //   controlName: "activeItems",
  //   title: "Indicator",
  //   checkboxOptions: [],
  // },
  
];
export const PermitFormConfig: Array<FilterType> = [
  {
    inputType: InputTypes.TEXT,
    controlName: "permitCarrierName",
    title: "Carrier Name",
  },
  {
    inputType: InputTypes.TEXT,
    controlName: "PermitAccountNumber",
    title: "Account Number",
  },
  {
    inputType: InputTypes.TEXT,
    controlName: "PermitCarrierAccountId",
    title: "Carrier Account Id",
  },
  {
    inputType: InputTypes.TEXT,
    controlName: "PermitNumber",
    title: "Permit Number",
  },
  {
    inputType: InputTypes.TEXT,
    controlName: "CompanyRegNumber",
    title: "Company Registration Number",
  },
  { inputType: InputTypes.TEXT, controlName: "First_Name", title: "Name" },
  { inputType: InputTypes.TEXT, controlName: "Surname", title: "Surname" },
  {
    inputType: InputTypes.TEXT,
    controlName: "Vehicle_Registration",
    title: "Vehicle Registration",
  },
  {
    inputType: InputTypes.TEXT,
    controlName: "Application_Number",
    title: "Application Number",
  },
  {
    inputType: InputTypes.TEXT,
    controlName: "Company_Name",
    title: "Company Name",
  },
  // { inputType: InputTypes.DATE, controlName: 'StartDate', title: 'Start Date' },
  // { inputType: InputTypes.DATE, controlName: 'EndDate', title: 'End Date' },
  // { inputType: InputTypes.RANGE_DATE, controlName: 'RangeDate', title: 'Range Date' },
  {
    inputType: InputTypes.CHECKBOX,
    controlName: "statusMultiSelect",
    title: "Filter by one or more statuses...",
    checkboxOptions: [],
  },
];
export const VehicleFormConfig: Array<FilterType> = [
  {
    inputType: InputTypes.DROPDOWNWithIds,
    controlName: "vehicleType",
    title: "Vehicle Type",
  },
  {
    inputType: InputTypes.TEXT,
    controlName: "vinNumber",
    title: "VIN Number",
  },
  {
    inputType: InputTypes.TEXT,
    controlName: "regnumber",
    title: "Registration Number",
  },
];
export const PermitTypeFormConfig: Array<FilterType> = [
  {
    inputType: InputTypes.TEXT,
    controlName: "code",
    title: "Code",
  },
  {
    inputType: InputTypes.TEXT,
    controlName: "description",
    title: "Description",
  },
  {
    inputType: InputTypes.TEXT,
    controlName: "appFee",
    title: "App Fee",
  },
  {
    inputType: InputTypes.TEXT,
    controlName: "permitFee",
    title: "Permit Fees",
  },
  {
    inputType: InputTypes.RADIO,
    controlName: "active",
    title: "Choose Status",
    radioOptions: { true: "Active", false: "Inactive" },
  },
  {
    inputType: InputTypes.RADIO,
    controlName: "temp_long_ind",
    title: "Choose Permit Type",
    radioOptions: { 1: "Temporary", 0: "Long Term" },
  },
  {
    inputType: InputTypes.RADIO,
    controlName: "freight_passenger_ind",
    title: "Choose Vehicle Type",
    radioOptions: { 0: "Passenger", 1: "Freight" },
  },
];
export const PermitSearchConfig: Array<FilterType> = [
  {
    inputType: InputTypes.TEXT,
    controlName: "permitNumber",
    title: "Permit Number",
  },
  {
    inputType: InputTypes.TEXT,
    controlName: "regNumber",
    title: "Vehicle Registration Number",
  },
  {
    inputType: InputTypes.CHECKBOX,
    controlName: "statusMultiSelect",
    title: "Filter by one or more statuses...",
    checkboxOptions: [],
  },
];

export const ExtenalCarrierConfig: Array<FilterType> = [
  {
    inputType: InputTypes.TEXT,
    controlName: "carrierName",
    title: "Carrier Name",
  },
  {
    inputType: InputTypes.TEXT,
    controlName: "carrierAccountNumber",
    title: "Account Number",
  },
  {
    inputType: InputTypes.CHECKBOX,
    controlName: "statusMultiSelect",
    title: "Filter by one or more statuses...",
    checkboxOptions: [],
  },
];

export const DepotListFilterConfig: Array<FilterType> = [
  {
    inputType: InputTypes.TEXT,
    controlName: "name",
    title: "Name",
  },
  {
    inputType: InputTypes.TEXT,
    controlName: "town",
    title: "Town",
  },
  {
    inputType: InputTypes.TEXT,
    controlName: "RCP",
    title: "RCP",
  },
  {
    inputType: InputTypes.RADIO,
    controlName: "depot_type",
    title: "Choose Depot Type",
    radioOptions: { passenger: "Passenger", freight: "Freight" },
  },
];
export const MonthlyComplianceFilterConfig: Array<FilterType> = [
  {
    

    inputType: InputTypes.TEXT,
    controlName: "StartMonth",
    title: "Start Month",
  },
  {
    inputType: InputTypes.TEXT,
    controlName: "PermitNumber",
    title: "Permit Number",
  },
  {
    inputType: InputTypes.TEXT,
    controlName: "PermitType",
    title: "Permit Type",
  },
  {
    inputType: InputTypes.TEXT,
    controlName: "BorderCrossing",
    title: "Border Crossing",
  },
  {
    inputType: InputTypes.TEXT,
    controlName: "TempLong",
    title: "Temp or LongTerm",
  },
  {
    inputType: InputTypes.TEXT,
    controlName: "FreightPassenger",
    title: "Freight or Passenger",
  }
 
];
export const ANNUALCOMPLIANCESTATUS: Array<CheckboxOption> = [
  { desc: "Compliant", id: 0 },
  { desc: "Due", id: 1 },
  { desc: "OverDue", id: 25 },
  { desc: "QuoteAccepted", id: 13 },
  { desc: "FeePaid", id: 21 },
  { desc: "Submitted", id: 11 },
  { desc: "Approved", id: 51 },
  { desc: "Printed", id: 75 },
  { desc: "OnHold", id: 21 },
  { desc: "Collected", id: 79 },
  { desc: "Expired", id: 91 },
  { desc: "Rejected", id: 92 },
  { desc: "Cancelled", id: 93 },
];

export const AnnualComplianceFilterConfig: Array<FilterType> = [
  {
    inputType: InputTypes.TEXT,
    controlName: "AccountName",
    title: "Account Name",
  },
  {
    inputType: InputTypes.TEXT,
    controlName: "Account",
    title: "Account Number",
  },
  {
    inputType: InputTypes.TEXT,
    controlName: "VehicleRegistrationNumber",
    title: "Vehicle Registration Number",
  },
  {
    inputType: InputTypes.CHECKBOX,
    controlName: "StatusRangeFrom",
    title: "Status Range From",
    checkboxOptions: [...ANNUALCOMPLIANCESTATUS],
  },
  {
    inputType: InputTypes.CHECKBOX,
    controlName: "StatusRangeTo",
    title: "Status Range To",
    checkboxOptions: [...ANNUALCOMPLIANCESTATUS],
  },
];

export const ADMINANNUALCOMPLIANCESTATUS: Array<CheckboxOption> = [
  { desc: "Submitted", id: 11 },
  { desc: "Approved", id: 51 },
 
];
export const ADMINMONTHLYCOMPLIANCESTATUS: Array<CheckboxOption> = [
 

  { desc: "Approved", id: 51 },
  { desc: "Submitted", id: 11 },
  { desc: "Non-Compliant Monthly", id: 32 },
];

export const AdminAnnualComplianceListFilterConfig: Array<FilterType> = [
  {
    inputType: InputTypes.TEXT,
    controlName: "PermitNumber",
    title: "Permit Number",
  },

  {
    inputType: InputTypes.DROPDOWNWithIds,
    controlName: "PermitType",
    title: " Select Permit type",
  },

  {
    inputType: InputTypes.TEXT,
    controlName: "Carrier",
    title: "Carrier Code",
  },

  {
    inputType: InputTypes.TEXT,
    controlName: "VehicleRegistrationNumber",
    title: "Vehicle registration Number",
  },

  {
    inputType: InputTypes.RADIO,
    controlName: "FirstOrDuplicate",
    title: "Choose First Or Duplicate",
    radioOptions: { false: "First", true: "Duplicate" },
  },
  {
    inputType: InputTypes.CHECKBOX,
    controlName: "Statuses",
    title: "Status",
    checkboxOptions: [...ADMINANNUALCOMPLIANCESTATUS],
  },
];

export const AdminMonthlyComplianceListFilterConfig: Array<FilterType> = [
  {
    inputType: InputTypes.TEXT,
    controlName: "StartingMonth",
    title: "Starting Month",
  },


  {
    inputType: InputTypes.TEXT,
    controlName: "Suffix",
    title: "Account Name"
  },

  {
    inputType: InputTypes.TEXT,
    controlName: "AccountNumber",
    title: "Account Number",
  },

  {
    inputType: InputTypes.TEXT,
    controlName: "AccountType",
    title: "Account Type",
  },
  {
    inputType: InputTypes.CHECKBOX,
    controlName: "Statuses",
    title: "Status",
    checkboxOptions: [...ADMINMONTHLYCOMPLIANCESTATUS],
  },

];

export const SENDEMAILONANNUALCOMPLIANCE = [
  { desc: "LeadUser", id: 1 },
  { desc: "EditorUser", id: 2 },
  { desc: "ReadUser", id: 6 },
  { desc: "Owner", id: 11 },
  { desc: "Consultant", id: 12 },
  { desc: "Main_Contact", id: 21 },
];

export const CHANGESTATUSATBACKOFFICE = [
  { desc: "OnHold", id: 1 },
  { desc: "Deleted", id: 2 },
  { desc: "Rejected", id: 6 },
  // { desc: "Approved", id: 11 },
  { desc: "Collected", id: 12 },
  { desc: "Returned", id: 21 },
  { desc: "Cancelled", id: 21 },
];

export const CorspdcFormConfig: Array<FilterType> = [
  {
    inputType: InputTypes.TEXT,
    controlName: "carrierAccountNumber",
    title: "Account Number",
  },
  {
    inputType: InputTypes.RADIO,
    controlName: "filterUSelected",
    title: "Choose Application",
    radioOptions: { 0: "All", 1: "Application", 2:"Permit" },
  },
  {
    inputType: InputTypes.RADIO,
    controlName: "filterTSelected",
    title: "Choose Communication",
    radioOptions: { 0: "All", 1: "Sent", 2: "Received", 3: "Note" },
  },
    { inputType: InputTypes.DATE, controlName: 'dateFrom', title: 'Date From' },
   { inputType: InputTypes.DATE, controlName: 'dateTo', title: 'Date To' },
];

//#region Workflow
export const WFStatus: Array<CheckboxOption> = [
  { desc: "Assigned", id: "10" },
  { desc: "Approved", id: "100" },
  { desc: "Rejected", id: "200" },
  { desc: "Approval Recommended", id: "101" },
  { desc: "Submitted - Unassigned", id: "102" },
  { desc: "Sent Back - Need Attention", id: "300" },
  { desc: "Awaiting Applicant Feedback", id: "400" },
  { desc: "Reassigned", id: "500" },
  { desc: "Escalated", id: "600" } 
];


export const WFInboxFilterConfig: Array<FilterType> = [
  {
    inputType: InputTypes.TEXT,
    controlName: "CarrierName",
    title: "Carrier Name",
  },
  {
    inputType: InputTypes.DROPDOWNWithIds,
    controlName: "WFAppType",
    title: "Workflow Type",
  },
  {
    inputType: InputTypes.DROPDOWNWithIds,
    controlName: "WFRouteType",
    title: "Application Type",
  },
  {
    inputType: InputTypes.CHECKBOX,
    controlName: "Statuses",
    title: "Status",
    checkboxOptions: [...WFStatus],
  },
];

export const WFManageFilterConfig: Array<FilterType> = [
  {
    inputType: InputTypes.TEXT,
    controlName: "CarrierName",
    title: "Carrier Name",
  },
  {
    inputType: InputTypes.DROPDOWNWithIds,
    controlName: "WFAppType",
    title: "Workflow Type",
  },
  {
    inputType: InputTypes.DROPDOWNWithIds,
    controlName: "WFRouteType",
    title: "Application Type",
  },
  {
    inputType: InputTypes.CHECKBOX,
    controlName: "Statuses",
    title: "Status",
    checkboxOptions: [...WFStatus],
  },
];

//#endregion

